import { Redirect, Route, useLocation } from "react-router";
import SSOLogin from "./sso";
import OwnerLogin from "./owner";
import React, { Component, useContext, useEffect, useMemo, useRef, useState } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { LocaleUtil, SupportedLanguage } from "@eres/core";
import { SSOProfile } from "@10x/sso/SSOProfile";
import { dispatch, navigate, replaceNavigate } from "@my-dld/utils/StoreUtils";
import Actions from "@my-dld/actions";
import { hideLoading, showErrorMessage, showLoading } from "@my-dld/utils/UIUtils";
import { getAppServices } from "@10x/coreapp";
import { getUser, isLoggedIn } from "@10x/sso";
import { trackEvent } from "@my-dld/utils/Analytics";
import { AppContext } from "@my-dld/contexts/AppContext";
import urlParser from "urijs";
import * as base64 from "js-base64";
import { setTabuUser, setToken } from "@my-dld/utils/User";
import { IdentityApi } from "@10x/dubai-rest-api";
import { navigateToSSOApp } from "./utils";
import { getCriticalNotifications } from "@my-dld/utils/UserNotificationHandler";

function LoginHandler( props: RoutedViewProps ) {
	let { location } = props;
	const done = useRef( false );
	const pp = props.match.url.replace( /\/$/, "" );
	const [ token, error, moduleName ] = useMemo( () => {
		let loginModule = "sso";
		if ( location && location.search ) {
			let x = urlParser( location.search ).query( true ) as any;
			const appId = x.appId ?? x.appid;
			x.appId = appId;
			let passState: IAppLoginState | undefined = undefined;
			if ( x.state ) {
				const state = JSON.parse( base64.decode( x.state ) ) as IAppLoginState;
				if ( state && state.module === "uaepass" ) {
					passState = state;
				}
			}
			if ( passState ) {
				const isBussinessUser = passState?.sso === true;
				loginModule = isBussinessUser ? "sso" : "owner";
			}
			if ( x.error ) {
				return [ null, x.error, loginModule ];
			} else if ( passState ) {
				if ( passState.mode === "login" ) {
					x.token = x[ "rest-token" ];
					if ( x.token ) {
						return [ x.token, null, loginModule ];
					}
				}
			} else if ( x.appId ) {
				let cb = x.callback;
				cb = cb ?? "";
				cb = encodeURIComponent( cb );
				return [ null, null, `sso/${ x.appId }/${ cb }` ];
			}
		}
		return [ null, null, loginModule ];
	}, [ location ] );
	if ( !done.current ) {
		done.current = true;
		if ( error != null ) {
			showErrorMessage( error.toString() );
		}
		if ( token != null ) {
			showLoading();
			setToken( token );
			IdentityApi.me().then( x => {
				const profile = x?.response?.profile;
				if ( profile ) {
					dispatch( Actions.SET_IS_UAE_PASS_USER, true );
					setTabuUser( profile );
					navigate( "/mydld" );
				}
				hideLoading();
			} ).catch( e => {
				showErrorMessage( e.toString() );
				hideLoading();
				navigate( `${ pp }/${ moduleName ?? "" }` );
			} );
		}
	}

	if ( token != null ) {
		return <></>;
	}
	return <>
		<Redirect to={ `${ pp }/${ moduleName ?? "" }` }/>
	</>;
}

export default function Login( props: RoutedViewProps ) {
	const pp = props.match.url;
	const app = useContext( AppContext );
	let { location } = props;
	if ( app.user ) {
		if ( location && location.search ) {
			let x = urlParser( location.search ).query( true ) as any;
			const appId = x.appId ?? x.appid;
			x.appId = appId;
			if ( x.appId ) {
				const ssoAppId = x.appId;
				let cb = x.callback;
				cb = cb ?? "";
				const profile = SSOProfile.getProfile();
				if ( getCriticalNotifications() != null ) {
					navigate( "/mydld" );
					return <></>;
				}
				if ( profile && ssoAppId ) {
					if ( profile.applications ) {
						const app = profile.applications.find( x => x.applicationId + "" === ssoAppId );
						if ( app ) {
							showLoading();
							if ( cb ) {
								navigateToSSOApp( cb! );
							} else {
								const xApp = window.ssoApps.find( x => x.id === ssoAppId );
								if ( xApp && xApp.url && xApp.isLive ) {
									navigateToSSOApp( LocaleUtil.getLocalValue( xApp.url ) );
								}
							}
							return <></>;
						} else {
							const xApp = window.ssoApps.find( x => x.id === ssoAppId );
							let url = LocaleUtil.getLocalValue( xApp?.url );
							if ( xApp && ( url || cb ) && xApp.universalApp ) {
								if ( cb ) {
									navigateToSSOApp( cb! );
								} else if ( url.startsWith( "#" ) ) {
									let xp = url.substr( 1 );
									navigate( xp );
								} else
									navigateToSSOApp( url );
							} else if ( props.history ) {
								props.history.replace( {
									pathname: "/sso/noapp/" + ssoAppId,
									search: props.location.search
								} );
							}
							return <></>;
						}

					}
				}
			}
		}
		return <Redirect to="/mydld"/>;
	}
	return <>
		<Route
			exact={ true }
			path={ pp }
			component={ LoginHandler }
		/>
		<Route path={ `${ pp }/sso/:appId?/:callback?` } exact={ true } component={ SSOLogin }/>
		<Route path={ `${ pp }/owner` } exact={ true } component={ OwnerLogin }/>
	</>;
}

export interface IAppLoginState {
	module: "uaepass" | string;
	sso?: boolean;
	app?: string;
	cb?: string;
	mode: "login" | "logout" | "reg";
	ln: SupportedLanguage;
	error?: string;
}

export function AppHandler( props: { q: { appId: string; callback?: string } } ) {
	let { q } = props;
	let ls = useLocation();
	const l = ls.pathname;
	const s = ls.search;
	useEffect( () => {
		const profile = SSOProfile.getProfile();
		if ( profile ) {
			if ( getCriticalNotifications() != null ) {
				navigate( "/mydld" );
				return;
			}
			if ( q.appId ) {
				const appId = q.appId;
				let cb = q.callback;
				cb = cb ?? "";
				if ( profile.applications ) {
					const app = profile.applications.find( x => x.applicationId + "" === appId );
					if ( app ) {
						if ( cb ) {
							navigateToSSOApp( cb! );
						} else {
							const xApp = window.ssoApps.find( x => x.id === appId );
							if ( xApp && xApp.url && xApp.isLive ) {
								navigateToSSOApp( LocaleUtil.getLocalValue( xApp.url ) );
							}
						}
					} else {
						const xApp = window.ssoApps.find( x => x.id === appId );
						if ( xApp && ( xApp.url || cb ) && xApp.isLive && xApp.universalApp ) {
							let url = LocaleUtil.getLocalValue( xApp.url );
							if ( cb ) {
								navigateToSSOApp( cb! );
							} else if ( url.startsWith( "#" ) ) {
								let xp = url.substr( 1 );
								navigate( xp );
								return;
							} else {
								navigateToSSOApp( url );
							}
						} else {
							navigate( "/mydld" );
							return;
						}
					}
					navigate( "/mydld" );
				}
			}
		} else if ( isLoggedIn() ) {
			navigate( "/mydld" );
		} else if ( l.startsWith( "/register" ) ) {
		} else if ( l.startsWith( "/sso" ) ) {
		} else if ( l.startsWith( "/logout" ) ) {
		} else if ( !l.startsWith( "/login" ) ) {
			if ( q.appId ) {
				let cb = q.callback;
				cb = cb ?? "";
				cb = encodeURIComponent( cb );
				let x = urlParser( window.location.href );
				x = x.query( "" ).hash( `/login/sso/${ q.appId }/${ cb }` );
				window.location.href = x.toString();
				return;
			}
			let x = urlParser( window.location.href );
			x = x.query( "" ).hash( "/login" );
			window.location.href = x.toString() + "?" + q;
			return;
		}
	}, [] );

	return null;
}

export function QueryHandler() {
	const l = useLocation();
	if ( l.search ) {
		let x = urlParser( l.search ).query( true ) as any;
		const appId = x.appId ?? x.appid;
		x.appId = appId;
		if ( x.state ) {
			const state = JSON.parse( base64.decode( x.state ) ) as IAppLoginState;
			if ( state && state.module === "uaepass" ) {
				return <UaePassHandler data={ state }/>;
			}
		} else if ( x.appId ) {
			return <AppHandler q={ x }/>;
		}
	}
	if ( l.pathname === "/" || l.pathname === "" ) {
		return <Redirect to={ "/mydld" }/>;
	}
	return <React.Fragment/>;
}


export function UaePassHandler( props: { data: IAppLoginState } ) {
	let { data } = props;
	const l = useLocation();
	const [ done, setDone ] = useState( false );
	useEffect( () => {
		handleUAEPassState( data, l.search, l.pathname ).then( x => {
			if ( !x ) {
				let x = urlParser( window.location.href );
				x = x.query( "" ).hash( "/mydld" );
				window.location.href = x.toString();
			}
		} );
	}, [] );
	return <React.Fragment/>;
}

export function handleUAEPassState( state: IAppLoginState, orgQuery?: string, path?: string ): Promise<boolean> {
	const post = {
		callback: () => {
		},
		result: false,
	};
	if ( state.sso ) {
		if ( state.error ) {
			showErrorMessage( state.error );
		}
		if ( state.mode === "logout" ) {
			const from = state.sso ? "/sso" : "/owner";
			getAppServices().storeService.getStore().dispatch( {
				type: Actions.USER_LOGGED_OUT,
			} );
			trackEvent( "Login", "Logout" );
			post.callback = () => {
				navigate( "/logout" + from );
			};
			post.result = true;
		} else {
			const profile = SSOProfile.getProfile();

			if ( profile ) {
				dispatch( Actions.SET_IS_UAE_PASS_USER, true );
			}
			if ( profile && state.app ) {
				if ( getCriticalNotifications() != null ) {
					post.callback = () => {
						navigate( "/mydld" );
					};
					post.result = true;
				} else if ( profile.applications ) {
					const app = profile.applications.find( x => x.applicationId + "" === state.app );
					if ( app ) {
						if ( state.cb ) {
							post.callback = () => {
								navigateToSSOApp( state.cb! );
							};
							post.result = true;
						} else {
							const xApp = window.ssoApps.find( x => x.id === state.app );
							if ( xApp && xApp.url && xApp.isLive ) {
								post.callback = () => {
									navigateToSSOApp( LocaleUtil.getLocalValue( xApp.url ) );
								};
								post.result = true;
							}
						}
					} else {
						const xApp = window.ssoApps.find( x => x.id === state.app );
						let url = LocaleUtil.getLocalValue( xApp?.url );
						if ( xApp && ( url || state.cb ) && xApp.universalApp && xApp.isLive ) {
							if ( state.cb ) {
								post.callback = () => {
									navigateToSSOApp( state.cb! );
								};
								post.result = true;
							} else if ( url.startsWith( "#" ) ) {
								let xp = url.substr( 1 );
								post.callback = () => {
									navigate( xp );
								};
								post.result = true;
							} else {
								post.callback = () => {
									navigateToSSOApp( url );
								};
								post.result = true;
							}

						} else {
							post.callback = () => {
								replaceNavigate( "/sso/noapp/" + state.app! );
							};
							post.result = true;
						}
					}
				}
			}
		}

	} else {
		if ( state.mode === "reg" ) {
			post.callback = () => {
				navigate( "/sso/register", orgQuery );
			};
			post.result = true;
		} else if ( state.mode === "login" ) {
			if ( state.error ) {
				showErrorMessage( state.error );
			}
			if ( state.sso ) {
				post.callback = () => {
					navigate( "/login/sso", orgQuery );
				};
			} else {
				post.callback = () => {
					if ( !path?.startsWith( "/login/owner" ) )
						navigate( "/login/owner", orgQuery );
				};
			}
			post.result = true;
		} else if ( state.mode === "logout" ) {
			if ( getUser() != null ) {
				const from = state.sso ? "/sso" : "/owner";
				getAppServices().storeService.getStore().dispatch( {
					type: Actions.USER_LOGGED_OUT,
				} );
				trackEvent( "Login", "Logout" );
				post.callback = () => {
					navigate( "/logout" + from );
				};
				post.result = true;
			}
		}
	}
	return getAppServices().storeService.getPersistor().flush().then( () => {
		post.callback();
		return post.result;
	} ).catch( () => {
		post.callback();
		return post.result;
	} );
}


export interface ILoader {
	setLoading: ( isLoading: boolean ) => void;
}

export interface ILoginChannelComponent<P, S> extends Component<P & LoginChannelProps, S> {
	doLogin: ( loader: ILoader ) => Promise<boolean>;
}

export interface ILoginChannelComponentClass<P, S> {
	new( props: P, context?: any ): ILoginChannelComponent<P & LoginChannelProps, S>;
}

export interface LoginChannelProps {
	onLoginSuccess: () => void;
	doLogin: () => void;
}
